import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { useStore } from '../../../../../../../../store';
import { AVAILABLE_BILL_MODALS } from '../../consts';
import { markBillAsCanceledAPIAction } from './api/MarkBillAsCanceledAPI';
import { isBillStatusCanceled } from '../../../../utils';
import MarkBillAsCanceledSuccess from '../../../Toasts/MarkBillAsCanceledSuccess';

interface IProps {
  onClose: () => void;
  billStatus: string;
  billId: string;
  billNumber: string;
}

const MarkBillAsCanceled = ({ onClose, billStatus, billId, billNumber }: IProps) => {
  const getPersonalAccount = useStore((state) => state.getPersonalAccount);
  const user = useStore((state) => state.user);
  const { accountExternalId } = getPersonalAccount();
  const { customerId } = user;
  const removeBillFromList = useStore((state) => state.removeBillFromList);
  const setBillError = useStore((state) => state.setBillError);
  const setActiveBillModal = useStore((state) => state.setActiveBillModal);
  const showBillDetailsModal = useStore((state) => state.showBillDetailsModal);
  const setSelectedBill = useStore((state) => state.setSelectedBill);
  const { t } = useTranslation();
  const handleCancelInvoice = async () => {
    try {
      setActiveBillModal(AVAILABLE_BILL_MODALS.SPINNER);
      const response = await markBillAsCanceledAPIAction(customerId, accountExternalId, billId);
      setActiveBillModal(AVAILABLE_BILL_MODALS.NONE);
      if (isBillStatusCanceled(response?.status)) {
        toast(<MarkBillAsCanceledSuccess billNumber={billNumber} />, {
          position: toast.POSITION.TOP_CENTER,
          className: 'min-w-[343px] max-w-[420px] h-[44px] bg-bw08 !px-[25px]',
        });
        if (showBillDetailsModal) setSelectedBill(billId, response);
        setTimeout(() => {
          removeBillFromList(billStatus, billId);
        }, 0);
      }
    } catch (error: any) {
      setBillError(error);
      setActiveBillModal(AVAILABLE_BILL_MODALS.ERROR);
    }
  };
  return (
    <div
      className='cursor-default flex flex-nowrap flex-col w-[498px] bg-bw00 rounded-lg border-[1px] border-bw03 p-[24px] box-border'
      data-testid='BillsHub__Modal__Mark-as-Canceled'
    >
      <div className='text-bw08 font-metricRMedium leading-8 text-24 mb-2'>
        {t('BILL_PAY.MARK_AS_CANCELED.TITLE')}
        <span data-testid='invoiceNumberInCancelPopup'>{` #${billNumber}?`}</span>
      </div>
      <div className='text-bw07 font-metricR leading-6 text-lg mb-[35px]'>
        {t('BILL_PAY.MARK_AS_CANCELED.SUBTITLE')}
      </div>
      <div className='mt-[20px] flex justify-end gap-2.5'>
        <LiliButton
          id='doNotCancel'
          testId='doNotCancel'
          type={LiliButtonType.TERTIARY}
          title={t('BILL_PAY.MARK_AS_CANCELED.CANCEL')}
          className='w-[140px] h-[40px]'
          onClick={onClose}
        />
        <LiliButton
          id='yesCancelIt'
          testId='yesCancelIt'
          type={LiliButtonType.DESTRUCTIVE}
          title={t('BILL_PAY.MARK_AS_CANCELED.DELETE')}
          className='w-[140px] h-[40px]'
          onClick={handleCancelInvoice}
        />
      </div>
    </div>
  );
};

export default MarkBillAsCanceled;
